// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1mf0T","unreadBadge":"styles_unreadBadge__3-xe1","modalContent":"styles_modalContent__3rvSE","modal":"styles_modal__2Wjs9"};